// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XOGK","select":"styles_select__Ag-Wj"};